/* eslint-disable no-unused-expressions */
// @flow
/* eslint-disable no-useless-constructor */
import _ from 'lodash';
import React, { Component } from 'react';
import { Row, Col } from '@duxton-web/ui';
import ActionForm from './node-forms/ActionForm';
import DelayForm from './node-forms/DelayForm';
import SplitForm from './node-forms/SplitForm';
import JourneyStartForm from './node-forms/JourneyStartForm';
import ExitForm from './node-forms/ExitForm';
import { TYPE_TITLE_MAPPING, TYPE_INFO_MAPPING } from './utils/constants';
import ReadOnlyForm from './node-forms/ReadOnlyForm';
import { MoreInfoFilled, TickMarkFilled } from '@duxton-web/icons';

type Props = {
  node: { id: number, type: string, data: object },
  nextNodes: any,
  form: any,
  hasError: Boolean,
  refreshDiagram: Function,
};

class JourneyBuilderPanel extends Component {
  props: Props;
  constructor(props: Props) {
    super(props);
  }

  getFormComponent = (node: { id: Number, type: String, data: Object }) => {
    const { form, nextNodes, showSegmentModal, refreshDiagram } = this.props;
    const nodeComponentMapping = {
      action: <ActionForm form={form} node={node} />,
      wait: <DelayForm form={form} node={node} />,
      split: <SplitForm form={form} node={node} nextNodes={nextNodes} refreshDiagram={refreshDiagram} />,
      journeyStart: (
        <JourneyStartForm
          showSegmentModal={showSegmentModal}
          form={form}
          node={node}
        />
      ),
      exit: <ExitForm form={form} node={node} />,
    };

    return nodeComponentMapping[node.type];
  };

  getNodeIntroComponent = () => {
    const { node, hasError } = this.props;
    const nodeInfo = TYPE_INFO_MAPPING[node.type];
    return (
      <Row className="jb-node-intro">
        <Col>
          <img src={nodeInfo.icon} alt={''} />
        </Col>
        <Col>
          <div className="title">{nodeInfo.text}</div>
        </Col>
        {hasError ? <MoreInfoFilled className="error-state" /> : <TickMarkFilled className="success-state" />}
      </Row>
    );
  };

  getNextNodesComponent = () => {
    const { node, nextNodes } = this.props;
    return _.map(nextNodes, (nextNode, idx) => {
      return (
        <Row>
          <Col span={24}>
            {node && (
              <h3>
                {idx + 2}. {TYPE_TITLE_MAPPING[_.get(nextNode, 'type')]}
              </h3>
            )}
          </Col>
          <Col style={{ marginTop: 10 }} span={24}>
            <ReadOnlyForm node={nextNode} />
          </Col>
        </Row>
      );
    });
  };

  render() {
    const { node } = this.props;
    const nodeForm = node ? this.getFormComponent(node) : null;
    const nextComponents = this.getNextNodesComponent();
    const isSplitNode = node && node.type === 'split';
    return (
      <div>
        <div className="header">{node && this.getNodeIntroComponent()}</div>
        <div className="body">
          <Row>
            <Col span={24}>{nodeForm}</Col>
          </Row>
        </div>
        {!isSplitNode && <div className="foot">{nextComponents}</div>}
      </div>
    );
  }
}

export default JourneyBuilderPanel;
